module.exports = __webpack_public_path__ + "static/media/icon-managed-online.81ac8a1b.png";